import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, OPEN_EVENT } from "../lib/consent";

const INK = '#0f1d2f';

// Small, accessible analytics choice. Shown until the visitor accepts or declines;
// "Cookie preferences" in the footer reopens it to change or revoke.
export default function ConsentBanner() {
  const [open, setOpen] = useState(false);
  const firstBtn = useRef(null);

  useEffect(() => {
    if (/jsdom/i.test(navigator.userAgent)) return; // never part of prerendered HTML
    if (getConsent() === null) setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, reopen);
    return () => window.removeEventListener(OPEN_EVENT, reopen);
  }, []);

  useEffect(() => { if (open) firstBtn.current?.focus({ preventScroll: true }); }, [open]);

  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); };
  const current = getConsent();

  return (
    <div role="dialog" aria-modal="false" aria-labelledby="consent-title" aria-describedby="consent-desc"
      className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-sm bg-white border shadow-lg p-5"
      style={{ zIndex: 2000, borderColor: 'rgba(15,29,47,0.15)', color: INK }} data-testid="consent-banner">
      <p id="consent-title" className="text-xs tracking-widest uppercase" style={{ color: '#8f7d45' }}>Your privacy</p>
      <p id="consent-desc" className="mt-2 text-sm leading-relaxed" style={{ opacity: 0.8 }}>
        May we use Google Analytics cookies to understand how the site is used? No advertising, and you can change this anytime.{" "}
        <Link to="/privacy" className="underline" data-testid="consent-privacy-link">Privacy</Link>
      </p>
      {current && <p className="mt-2 text-xs" style={{ opacity: 0.6 }} data-testid="consent-current">Current choice: {current === "granted" ? "Accepted" : "Declined"}</p>}
      <div className="mt-4 flex gap-2">
        <button ref={firstBtn} type="button" onClick={() => choose("granted")}
          className="flex-1 px-4 py-2.5 text-xs tracking-widest uppercase focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B6A46D]"
          style={{ backgroundColor: INK, color: '#fff' }} data-testid="consent-accept">Accept</button>
        <button type="button" onClick={() => choose("denied")}
          className="flex-1 px-4 py-2.5 text-xs tracking-widest uppercase border focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B6A46D]"
          style={{ borderColor: INK, color: INK }} data-testid="consent-decline">Decline</button>
      </div>
    </div>
  );
}
